import _ from 'lodash';
import { BaseController } from '../../../common/base/controller';
import { IbanPrefix } from '../inbox.constants';
import { OppositeTypes } from './ibanAssign/ibanAssign.constants';
import item from './ibanAssign/templates/item.tpl.html';

export class CategorizeIncomingDocumentController extends BaseController {
  constructor(
    controllerService,
    DocumentTypeSelectables,
    DocumentStatusSelectables,
    ReducedDocumentTypeSelectables,
    InboxIbanService,
    DocumentStatus,
    DocumentTypes,
    inboxDocumentService,
    $scope,
  ) {
    'ngInject';
    super({
      controllerService,
      DocumentTypeSelectables,
      DocumentStatusSelectables,
      ReducedDocumentTypeSelectables,
      InboxIbanService,
      DocumentStatus,
      DocumentTypes,
      inboxDocumentService,
      $scope,
    });

    this.suggest = {
      editable: true,
      delay: 300,
      minLength: 3,
      isOpen: false,
      templateUrl: item,
    };
  }

  get showDocumentStatusOption() {
    return !this.isFeatureActive(
      this.FeatureNames.FF_DISABLE_DOCUMENT_STATUS_FOR_INBOX,
    );
  }

  get showTicketIdInMetadata() {
    return this.envService.envConfig.env === 'development';
  }

  get envelope() {
    return this.inboxDocumentService.envelope;
  }

  get rejectionReason() {
    return this.envelope.rejectionReason;
  }

  set rejectionReason(value) {
    this.envelope.rejectionReason = value;
  }

  get fieldsDisabled() {
    return (
      !this.inboxDocumentService.selectedDocument ||
      Object.keys(this.inboxDocumentService.selectedDocument).length <= 0 ||
      this.inboxDocumentService.selectedDocument.closed
    );
  }

  set showStatus(val) {
    if (val) {
      if (
        !this.rejectionReason ||
        this.rejectionReason === this.DocumentStatus.OK
      ) {
        this.rejectionReason = this.DocumentStatus.INCOMPLETE_WITH_IBAN;
      } else {
        this.rejectionReason = this.DocumentStatus.OK;
      }
    } else {
      this.rejectionReason = this.DocumentStatus.OK;
    }
  }

  get showStatus() {
    return !(
      this.hasNoDocument ||
      !this.rejectionReason ||
      this.rejectionReason === this.DocumentStatus.OK
    );
  }

  get showIbanFields() {
    if (this.hasNoDocument) {
      return true;
    }
    return this.DocumentStatus.INCOMPLETE_WITHOUT_IBAN !== this.rejectionReason;
  }

  get hasNoDocument() {
    return !this.inboxDocumentService.selectedDocument || !this.envelope;
  }

  get DocumentSelect() {
    if (
      this.isFeatureActive(this.FeatureNames.FF_REDUCE_DOCUMENT_TYPES_FOR_INBOX)
    ) {
      return this.ReducedDocumentTypeSelectables;
    }
    return this.DocumentTypeSelectables;
  }

  get isWarrant() {
    return this.inboxDocumentService.isWarrant;
  }

  get aidRequestId() {
    if (this.inboxDocumentService.selectedDocument) {
      return this.inboxDocumentService.selectedDocument.aidRequestId;
    } else if (this.inboxDocumentService.envelope) {
      return this.inboxDocumentService.envelope.aidRequestId;
    } else {
      return '';
    }
  }

  $onInit() {
    this.fieldType = 'suggest';

    // Swap iban fields for warrant document type
    this.$scope.$watch('vm.envelope.documentType', (type) => {
      if (this.isWarrant) {
        this.fieldType = 'text';
      } else {
        this.fieldType = 'suggest';
      }
    });

    this.$scope.$watch('vm.envelope.rejectionReason', (key) => {
      if (!this.envelope) return;
      this.envelope.rejectionReasonText = this.$translate.instant(
        `inbox.fax.status.${_.camelCase(key)}.text`,
      );
    });

    this.errorMessages = {
      required: 'inbox.list.detail.iban.error.required',
      editable: 'inbox.list.detail.iban.error.editable',
      parse: 'inbox.list.detail.iban.error.parse',
    };
  }

  suggestIban(viewValue, type) {
    if (this.isWarrant) {
      return; // this should disable suggestions if documentType is 'WARRANT'. In this case we don't need the search.
    }
    // add prefix for iban search (required)
    viewValue = viewValue.startsWith(IbanPrefix)
      ? viewValue
      : IbanPrefix + viewValue;
    return this.InboxIbanService.find(
      viewValue,
      this.envService.getTenant(),
      type,
    ).then((result) => {
      result = result.data.map((item) => {
        item.matchQueryMarkup = this.getMarkupForIbanWithHighlightedSearchMatch(
          viewValue,
          item[type],
        );
        item.oppositeType = OppositeTypes[type]; // opposite of searched type.
        return item;
      });

      return result;
    });
  }

  getMarkupForIbanWithHighlightedSearchMatch(value, iban) {
    let rest = iban.substring(value.length, iban.length);
    return `<span><strong>${value.toUpperCase()}</strong>${rest}</span>`;
  }

  suggestIbanSelected($item, type) {
    if (this.isWarrant) {
      return; // this should disable suggestions if documentType is 'WARRANT'. In this case we don't need the search.
    }
    this.$timeout(() => {
      this.envelope[type] = $item[type];
      this.envelope[OppositeTypes[type]] = $item[OppositeTypes[type]];
      this.inboxDocumentService.selectedDocument.aidRequestId =
        $item.aidRequestId;
    });
  }
}
